<template>
  <div id="title-top">
    <div id="header" :style='headerbg'></div>
    <img v-show="title != '我' && title != '预警信息处置'" src="../assets/images/fh.png" @click="goback" alt=""><p>{{title}}</p>
  </div>
</template>
<script>
export default {
  data () {
    return {
      headerbg: {
        backgroundImage: 'url(' + require('../assets/images/header.png') + ')',
        backgroundSize: 'cover',
        opacity: `${this.opacity}`
      }
    }
  },
  props: ['title', 'opacity'],
  created () {
    console.log('透明度', this.opacity)
  },
  mounted () {
    console.log(-2)
  },
  methods: {
    goback () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>
<style lang="scss" scoped>
img{
  position: absolute;
  color: #f9f9f9 !important;
  top: 8px;
  left: 10px;
  z-index: 99;
}
  p{
    height: 6.6vh;
    width: 100%;
    font: 0.15rem SourceHanSansCN-Bold;
    font-weight: bold;
    color: #f9f9f9 !important;
    position: absolute;
    top: 0px;
    line-height: 6.6vh;
    text-align: center;
  }
  #header{
    width: 100%;
    height: 6.6vh;
  }
  #title-top{
    height: 6.6vh;
  }
</style>
